import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import SubPageNav from './js/sub-page-nav.component';

ComponentsFactory.getInstance().define('sub-page-nav', SubPageNav);
